import React, {useMemo} from 'react';
import Link from 'next/link';
import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import useFetchPlotDetails from '~api/useFetchPlotDetails';
import PlotImage from '~molecules/PlotPreview/PlotImage';
import PlotAddress from '~molecules/PlotPreview/PlotAddress';
import PlotTitle from '~molecules/PlotPreview/PlotTitle';
import {Routes} from '~constants/routes';
import Button from '~atoms/Button';
import {If} from '~atoms/If';
import {Loader} from '~atoms/Loader';
import PlotNFT from '~molecules/PlotNFT';

import {Close, Header, LoaderContainer, Sep, Wrapper} from './styles';
import PlotInfo from './PlotInfo';

type PlotPreviewProps = {
    id?: number;
    closeModal: () => void;
};

const PlotPreview: React.FC<PlotPreviewProps> = ({id, closeModal}) => {
    const t = useScopeTranslation('map', 'preview');
    const {data, isLoading} = useFetchPlotDetails(id);

    const nftId = useMemo(
        () => (data ? Number(data.nftId.replace(':', '')) : undefined),
        [data],
    );

    return (
        <Wrapper active={Boolean(id)} data-cy="PlotPreview">
            <Header>
                <Close onClick={closeModal} />
            </Header>
            <PlotImage plot={data} />

            {!isLoading ? (
                data && (
                    <>
                        <PlotTitle plot={data} withCopy />
                        <PlotInfo plot={data} />
                        <PlotAddress plot={data} />
                    </>
                )
            ) : (
                <LoaderContainer>
                    <Loader />
                </LoaderContainer>
            )}
            <If condition={data && data.land === 1}>
                <Sep />
                <Link href={{pathname: Routes.Plot, query: {id}}} passHref>
                    <Button as={'a'} variant={'stroked'}>
                        {t('seeDetails')}
                    </Button>
                </Link>
                {data && nftId !== undefined && (
                    <PlotNFT
                        isLand={data.isLand}
                        owner={data.owner?.walletAddress}
                        id={nftId}
                        marginTop={12}
                    />
                )}
            </If>
        </Wrapper>
    );
};

export default PlotPreview;
